import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CommonService } from '../@shared/services/common.service';
import { BaseClass } from '../@shared/base-class/base-class';
import { IbaseService } from '../@shared/base-service/ibase-service';
import { WebserviceService } from '../@shared/services/webservice.service';
declare var $: any;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent extends BaseClass<any> implements OnInit {
  isIn: boolean = false;
  public wpLink = '';
  constructor(public _common: CommonService, public router: Router, public service: WebserviceService) {
    super();
    document.body.classList.remove('hide-sidebar');
  }

  ngOnInit(): void {
    $('#SideMenu a').click((e: any) => {
      $('#SideMenu .collapse').collapse('hide');
    });

    $(() => {
      $('[data-toggle="tooltip"]').tooltip()
    });

    $(() => {
      $('.button-menu-mobile').on("click", () => {
        $('body').addClass("sidebar-enable");
      });
    });

    $(() => {
      $('.menuClose').on("click", () => {
        $('body').removeClass("sidebar-enable");
      });
    });

    if (this.isLogin()) {
      this.getContactInfo();
    }

  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getContactInfo() {
    this.userData = this.getLocalItem('user');
    if (this.userData?.branch_panel_active == 1) {
      let url = this.userData.contact_info.replace(':domain', this.env.host.domain);
      // let url = `https://reddypanel.com/contact/reddybook.club/358417/Jnq8MNgo9g5R2SCDf8d35db89cdcdfc9d975bd67e0309d22`; //testURL
      this.getServices().Get(url).subscribe(
        (res) => {
          if (res?.error == 0) {
            this.wpLink = res?.link;
            // removeFreshChat();
          }
        },
        (err) => {
          console.log(err);
        });
    }
  }

  ngDoCheck() {
    if (this.isIn == false && this.isLogin()) {
      this.isIn = true;
      this.getContactInfo();
    }
  //   let expireTime = (localStorage.getItem(`${environment.panel}expiry`)) ? new Date(localStorage.getItem(`${environment.panel}expiry`) as any) : new Date();
  //   let currentTime = new Date();

  //   if (currentTime > expireTime || currentTime.getTime() > expireTime.getTime()) {
  //     this._common.removeLocalstorage();
  //     this.router.navigate(['/home']);

  //   }
  }
}
